function fetchDataset(url, data, doneCallback, $element, failCallback) {
  var $loader = $element.find('.dashboard-chart-loader');
  var $alert = $element.find('.dashboard-chart-alert');

  function onFail(onFailCallback) {
    $alert.slideDown();
    $loader.fadeOut();

    if (onFailCallback) {
      onFailCallback();
    }
  }

  $.ajax({
    method: 'GET',
    url: url,
    data: data,
    dataType: 'json',
    beforeSend: function beforeSend() {
      $loader.fadeIn();
      $alert.slideUp();
    }
  }).done(function (json_response) {
    if (json_response.error) {
      onFail(failCallback);
      return;
    }

    doneCallback(json_response);
    $loader.fadeOut();
  }).fail(function () {
    onFail(failCallback);
  });
}

var FetchDataset = {
  fetch: fetchDataset
};
export default FetchDataset;